import React, { useContext, FormEvent, ChangeEvent, useState } from "react";

import Input from "../../../components/Form/Input";
import Password from "../../../components/Form/Password";
import Button from "../../../components/Form/Button";
import AuthContext from "../../../contexts/AuthContext";
import { SimpleResponse } from "../../../services/api/Request";
import User, { IUser } from "../../../services/api/User";
import ImgPlaceholder from "../assets/images/profile-placeholder.svg";
import { SetModal } from "../../../components/Modal";
import { default as PasswordUtil } from "../../../services/utils/Password";
import "./assets/css/style.css";

const FileChecker = {
  checkMimeType: (event: ChangeEvent<HTMLInputElement>) => {
    const files: FileList = event.target.files!;
    const types: string[] = ["image/png", "image/jpeg", "image/gif"];
    let err: string = "";

    for (let x = 0; files && x < files.length; x++)
      if (types.every((type) => files.item(x)!.type !== type))
        err += files[x].type + " is not a supported format\n";

    if (err !== "") {
      event.target.nodeValue = null;
      console.log(err);
      return false;
    }
    return true;
  },
  maxSelectFile: (event: ChangeEvent<HTMLInputElement>) => {
    const files: FileList = event.target.files!;
    if (files.length > 1) {
      const msg = "Only 1 image can be uploaded at a time";
      event.target.nodeValue = null;
      console.log(msg);
      return false;
    }
    return true;
  },
  checkFileSize: (event: ChangeEvent<HTMLInputElement>) => {
    const files: FileList = event.target.files!;
    let size = 2000000; // 2MB
    let err = "";
    for (var x = 0; x < files.length; x++) {
      console.log(files[x].size);
      if (files[x].size > size)
        err += files[x].type + " is too large, please pick a smaller file\n";
    }

    if (err !== "") {
      event.target.nodeValue = null;
      console.log(err);
      return false;
    }
    return true;
  },
};

const PasswordChecker: any = (password: string, passwordConfirm: string) => {
  let empty = password === "";
  let strength = PasswordUtil.GetStrength(password);
  let equal = password === passwordConfirm;
  let message =
    empty || (strength === 5 && equal)
      ? ""
      : strength < 5
      ? "Your password does not satisfy the current policy requirements"
      : "The password confirmation does not match";

  return {
    pass: empty || (strength === 5 && equal),
    Message: message,
  };
};
const FormLogin: React.FC = () => {
  const { user, UpdateAuthUser } = useContext(AuthContext);
  const [message, setMessage] = useState("");
  const [response, setResponse] = useState<SimpleResponse>();
  const [selectedFile, setSelectedFile] = useState<File | undefined>(undefined);
  const [imagePreview, setImagePreview] = useState<string>(
    user!.picture || ImgPlaceholder
  );
  const [passStrength, setPassStrength] = useState("");
  const [passEqual, setPassEqual] = useState("");

  async function handleFormSubmit(event: FormEvent) {
    event.preventDefault();

    const formData: FormData = new FormData(event.target as HTMLFormElement);
    const formData2: FormData = new FormData();

    const checkPwd = PasswordChecker(
      formData.get("password"),
      formData.get("password_confirm")
    );

    if (checkPwd.pass) {
      formData2.append("Password", formData.get("password")!);

      formData2.append("Name", formData.get("name")!);
      formData2.append("PictureFile", selectedFile!);

      const response: SimpleResponse = await User.UpdateInfo(
        user!.id,
        formData2
      );
      setMessage(response.message);
      setResponse(response);

      if (response.status === 200) UpdateAuthUser();
    } else {
      setMessage(checkPwd.Message);
      setResponse(checkPwd);
    }
  }

  function readImagesAndSetAsBackground(event: ChangeEvent<HTMLInputElement>) {
    var files: FileList = event.target.files!;
    if (
      FileChecker.maxSelectFile(event) &&
      FileChecker.checkFileSize(event) &&
      FileChecker.checkMimeType(event)
    ) {
      var f = files[0];
      //console.log(f);
      setSelectedFile(f);
      setImagePreview(URL.createObjectURL(f));
    }
  }

  function checkPasswordStrength(event: ChangeEvent<HTMLInputElement>) {
    let i: HTMLInputElement = event.target;
    if (i.value !== "") {
      let strength = PasswordUtil.GetStrength(i.value);
      setPassStrength("Strength" + strength);
    } else setPassStrength("");

    checkPasswordEqual();
  }

  function checkPasswordEqual() {
    let origin: HTMLInputElement | null = document.getElementById(
      "password"
    ) as HTMLInputElement;
    let confirm: HTMLInputElement | null = document.getElementById(
      "password_confirm"
    ) as HTMLInputElement;
    if (origin!.value !== "")
      setPassEqual(origin!.value !== confirm!.value ? "Odd" : "Even");
    else setPassEqual("");
  }

  return (
    <React.Fragment>
      {response
        ? SetModal.FromResponse(response, () => {
            setResponse(undefined);
          })
        : null}
      <form className="form profile__form" onSubmit={handleFormSubmit}>
        <div className="row profile__row">
          <div className="col--small">
            <div
              className="picContainer"
              style={{ backgroundImage: "url(" + imagePreview + ")" }}
            ></div>
            <div className="upload-btn-wrapper">
              <button className="upload-btn-wrapper__btn">Upload Photo</button>
              <input
                type="file"
                name="picture"
                accept="image/png, image/jpeg, image/jpg"
                onChange={readImagesAndSetAsBackground}
              />
            </div>
          </div>
          <div className="col--big">
            <div className="form__group-container">
              <div className="col--2">
                <Input name="name" title="name" value={user && user.name} />
              </div>
              <div className="col--2">
                <Input
                  name="email"
                  title="e-mail"
                  value={user && user.email}
                  disabled={true}
                />
              </div>
            </div>
            <div className="form__group-container">
              <div className="col--2">
                <Password
                  name="password"
                  title="password"
                  value={user && user.password}
                  className={passStrength}
                  onKeyUp={checkPasswordStrength}
                />
                <div id="passwordHelper">
                  <span
                    className="iconHelper"
                    onMouseOver={(event: FormEvent) => {
                      let hpr: HTMLElement | null = document.getElementById(
                        "passwordHelper"
                      );
                      hpr!.className = "displayHelper";
                    }}
                    onMouseOut={(event: FormEvent) => {
                      let hpr: HTMLElement | null = document.getElementById(
                        "passwordHelper"
                      );
                      hpr!.className = "";
                    }}
                  >
                    ?
                  </span>
                  <div className="passwordHelper__info">
                    <span className="passwordHelper__title">
                      The password must contain:
                    </span>
                    <br />
                    <ul className="passwordHelper__list">
                      <li className="passwordHelper__list-item">
                        at least one number digit
                      </li>
                      <li className="passwordHelper__list-item">
                        at least one lowercase letter
                      </li>
                      <li className="passwordHelper__list-item">
                        at least one uppercase letter
                      </li>
                      <li className="passwordHelper__list-item">
                        between 8 and 36 characters
                      </li>
                      <li className="passwordHelper__list-item">
                        at least one special character
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col--2">
                <Password
                  name="password_confirm"
                  title="retype password"
                  value={user && user.password}
                  className={passEqual}
                  onKeyUp={checkPasswordEqual}
                />
              </div>
            </div>
            <div className="form__group-container">
              <div className="col--2">
                <Input
                  name="group"
                  title="user country"
                  value={user && user.group.name}
                  disabled={true}
                />
              </div>
              <div className="col--2">
                <Input
                  name="profile"
                  title="user type"
                  value={user && user.profile.name}
                  disabled={true}
                />
              </div>
            </div>
            <Button title="Save" className="button button--blue" />
          </div>
        </div>
      </form>
    </React.Fragment>
  );
};

export default FormLogin;
